// All site copy lives here. Edit this file, rebuild, and deploy to change the site.
// Image names refer to files in public/images/.

export const content = {
  siteName: "The Milan",
  siteTitle: "Milan Pines | Eight suites. Infinite summer.",
  sections: {
    rooms: { visible: true, navTitle: "Rooms" },
    outdoor: { visible: true, navTitle: "Outdoor" },
    indoor: { visible: false, navTitle: "Indoor" },
    contact: { visible: true, navTitle: "Contact" },
  },
  hero: {
    title: "Milan Pines",
    subtitle: "Eight suites. Infinite summer.",
    description:
      "Milan Pines is a statement-making new build on Seaview Walk—eight two-level suites, a private pool courtyard made for tanning and togetherness. Built for chosen family, late nights, and the kind of summers you don’t post everything about.",
    announcement: "Now offering full, half, and quarter shares for Summer 2027.",
    backgroundImage: "1769370034130-0021.jpg",
  },
  rooms: {
    title: "Two floors. Total privacy. Spa-level calm with Pines-approved style.",
    description:
      "Two levels, perfectly balanced. Lounge and linger downstairs; slip upstairs to a spa-style bedroom made for recovery, beauty sleep, and disappearing till noon.",
    images: [
      "1769477860939-0026.jpg",
      "1769477959840-0040.jpg",
      "1769477897110-0035.jpg",
      "1769478308960-0067.jpg",
      "1769477918065-0033_Unit_2.jpg",
      "1769370167678-0028.jpg",
      "1769477874471-0036.jpg",
      "1769370174929-0029.jpg",
      "1769478059743-0069.jpg",
      "1769478159700-0043.jpg",
      "1769478191237-0064.jpg",
      "1769478229874-0068.jpg",
    ],
  },
  outdoor: {
    title: "Outdoor",
    description:
      "The outdoor spaces at Milan Pines are designed for peak summer behavior. A private pool and hot tub anchor the courtyard, with an outdoor kitchen featuring two grills—because one is never enough. Rinse off in the outdoor showers, stretch out in the sun, and let the day (and night) unfold naturally.",
    amenities: ["Pool", "Hot Tub", "Two Full Size BBQ Grills", "Outdoor Shower"],
    images: [
      "1769375133656-0012.jpg",
      "1769375137887-0010.jpg",
      "1769375152807-0008.jpg",
      "1769375163939-0024.jpg",
      "1769375181966-0026.jpg",
      "1769375202773-0084.jpg",
    ],
  },
  indoor: {
    title: "Indoor",
    description:
      "The common spaces at Milan Pines are made for gathering—with intention. A soaring, light-filled great room flows effortlessly from the kitchen to the living area, creating a natural hub for coffee, cocktails, and whatever the day turns into. Big enough for everyone, polished enough to impress, and relaxed enough to stay awhile.",
    images: [
      "1769375375338-0072.jpg",
      "1769375395912-0075.jpg",
      "1769375403229-0076.jpg",
      "1769375447001-0079.jpg",
    ],
  },
  contact: {
    title: "Ready When You Are",
    description:
      "Full, half, and quarter shares are now available for Summer 2027. If Milan Pines feels like your kind of place, connect with one of the brokers below for details and availability.",
    emails: [
      "contact@asummerplacerealty.com",
      "alex@pinesharbor.com",
      "josh@bekin.io",
      "nancy@fireislandpines.com",
      "vinnie@vpfireislandpines.com",
    ],
    phone: "",
  },
};

export type SiteContent = typeof content;

export const imageUrl = (name: string) => (name ? `/images/${name}` : "");
